import { gql } from '@apollo/client';

export const COMPONENT_LISTS_QUERY = gql`
    query componentLists {
        componentLists {
            edges {
                node {
                    type
                    componentListId
                    uuids
                }
            }
        }
    }
`;
